import { useAccessFilterCheck } from 'shared/hooks';
import styled from 'styled-components';

import { NavigateActionAskForOpportunities, NavigateActionUpdateAvailability } from '../components';
import NavigateActionUpdatePreferences from '../components/AdditionalActions/NavigateActionUpdatePreferences';

export function OfferPageAdditionalActions() {
    const jobPreferencesEnabled = useAccessFilterCheck({ feature: 'CandidatesJobPreferences' });

    return (
        <OfferPageAdditionalSectionContainer>
            { jobPreferencesEnabled && <NavigateActionUpdatePreferences /> }
            { !jobPreferencesEnabled && <NavigateActionAskForOpportunities /> }
            <NavigateActionUpdateAvailability />
        </OfferPageAdditionalSectionContainer>
    );
}

const OfferPageAdditionalSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${ ({ theme }) => theme.size.size_15 };
`;
